import { render, staticRenderFns } from "./FullTxtArtAnalysisResultTip.vue?vue&type=template&id=3f6ddbf4&scoped=true"
import script from "./FullTxtArtAnalysisResultTip.vue?vue&type=script&lang=js"
export * from "./FullTxtArtAnalysisResultTip.vue?vue&type=script&lang=js"
import style0 from "./FullTxtArtAnalysisResultTip.vue?vue&type=style&index=0&id=3f6ddbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ddbf4",
  null
  
)

export default component.exports